export var PasswordResetIA = function PasswordResetIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESET_PASSWORD(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize), FIRST_STEP_TO_RESET_PASSWORD(strictLocalize), SECOND_STEP_TO_RESET_PASSWORD(strictLocalize), THIRD_STEP_TO_RESET_PASSWORD(strictLocalize), THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize)];
    }
  };
};
var RESET_PASSWORD = function RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "8BAYrT",
    defaultMessage: [{
      "type": 0,
      "value": "Redefinir palavra-passe"
    }]
  });
};
var IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD = function IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "uaYTsO",
    defaultMessage: [{
      "type": 0,
      "value": "Se desejar redefinir a sua palavra-passe, siga os passos abaixo:"
    }]
  });
};
var FIRST_STEP_TO_RESET_PASSWORD = function FIRST_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "FCoWDD",
    defaultMessage: [{
      "type": 0,
      "value": "1. Clique no botão Iniciar Sessão no canto superior direito da página inicial"
    }]
  });
};
var SECOND_STEP_TO_RESET_PASSWORD = function SECOND_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "jmoi8G",
    defaultMessage: [{
      "type": 0,
      "value": "2. Introduza o endereço de e-mail de início de sessão e prima Enter"
    }]
  });
};
var THIRD_STEP_TO_RESET_PASSWORD = function THIRD_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "fMuh5K",
    defaultMessage: [{
      "type": 0,
      "value": "3. No ecrã seguinte, clique no link que diz \"Esqueceu-se da palavra-passe? Redefina-a\""
    }]
  });
};
var THIS_WILL_SEND_AN_AUTOMATED_EMAIL = function THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "NWeLC2",
    defaultMessage: [{
      "type": 0,
      "value": "Isto enviará um e-mail automático para o seu endereço de e-mail de início de sessão para ajudar a redefinir a palavra-passe. Se não receber o e-mail, verifique se escreveu o endereço corretamente e verifique a pasta de spam. Se tiver algum problema, contacte-nos através das opções abaixo."
    }]
  });
};